// extracted by mini-css-extract-plugin
export default {"list":"eEkVwmzp6iAJO2wAcPhp"};